import { createApp } from "vue";
import FileDropzone from "./components/FileDropzone.vue";
import { VUE_MOUNTED_ATTRIBUTE, getMountElements } from "./utils/vueMount";
import { parseBoolean } from "./utils/parseBoolean";

export function initSheetFileDropzoneApp(root = document) {
  const apps = [];

  getMountElements(root, "[data-vue-sheet-file-dropzone]").forEach((element) => {
    if (!element || element.hasAttribute(VUE_MOUNTED_ATTRIBUTE)) {
      return;
    }

    const app = createApp(FileDropzone, {
      accept: element.dataset.accept || "",
      disabled: parseBoolean(element.dataset.disabled),
      iconClass: element.dataset.iconClass || "bi bi-cloud-arrow-up",
      title: element.dataset.title || "Upusc tutaj plik",
      description: element.dataset.description || "",
      inputId: element.dataset.inputId || "",
      inputName: element.dataset.inputName || "",
      required: parseBoolean(element.dataset.required),
      multiple: parseBoolean(element.dataset.multiple),
      compact: parseBoolean(element.dataset.compact),
      resetAfterSelect: false,
    });

    app.mount(element);
    element.setAttribute(VUE_MOUNTED_ATTRIBUTE, "1");
    apps.push(app);
  });

  return apps.length === 0 ? null : apps;
}
